import React, { FC, PropsWithChildren } from 'react'

import { defaultContextId } from 'components/layout/MambaLayout/Context'
import { WrapperLayout } from 'components/layout/WrapperLayout'
import { useLayoutContext } from 'hooks/useLayoutContext'

export const PhotoViewerCreateBaseUrl: FC<PropsWithChildren> = ({
  children,
}) => {
  const { id = defaultContextId } = useLayoutContext()

  if (id === defaultContextId) {
    return <WrapperLayout>{children}</WrapperLayout>
  }

  return <>{children}</>
}
